import classNames from 'classnames';
import { memo } from 'react';

import { FileStatusPanelItem, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { SHARED_PANEL_ITEM_CLASS_NAMES } from '../../constants/ClassNames';
import { getSubtitleWithProgress } from '../../utils';
import { FileStatusThumbnail } from './FileStatusThumbnail';
import { type FileTrackingItem } from './FileStatusTrackingPanel';

export type FileStatusPanelListItemCancelledProps = {
  item: FileTrackingItem;
};

export const FileStatusTrackingPanelListItemAborted = memo(
  ({
    item: { ext, onRowClick, previewLoader, avatar, title, thumbnailSource, sizeInBytes, subtitle, status },
  }: FileStatusPanelListItemCancelledProps) => {
    return (
      <FileStatusPanelItem
        avatar={avatar ?? <FileStatusThumbnail ext={ext} status={status} thumbnailSource={thumbnailSource} />}
        buttons={null}
        className={classNames(
          'opacity-60',
          SHARED_PANEL_ITEM_CLASS_NAMES,
          !!onRowClick && 'cursor-pointer ads:hover:bg-hover-subtle hover:bg-gray-3',
        )}
        onClick={onRowClick}
        previewLoader={previewLoader}
        subtitle={
          <FileStatusSubtitle className="truncate">
            {subtitle ?? getSubtitleWithProgress({ sizeInBytes, title: 'Cancelled', uploadedBytes: sizeInBytes })}
          </FileStatusSubtitle>
        }
        title={<FileStatusTitle className="text-12">{title}</FileStatusTitle>}
      />
    );
  },
);

FileStatusTrackingPanelListItemAborted.displayName = 'FileStatusTrackingPanelListItemAborted';
